import {AssetCouponUsageSearchOptionDescription} from "../../../data/description/asset/AssetCouponUsageSearchOptionDescription"
import {AssetCouponUsageSearchOption} from "../../../data/search-option/asset/AssetCouponUsageSearchOption"
import {ListOptionFieldProps, ListOptionWrapper} from "../../ListOption"
import {Field, Input} from "@fluentui/react-components"
import {StatePair, useStatePair} from "react-type-extension"

export function AssetCouponUsageSearchOptionField(props: ListOptionFieldProps<AssetCouponUsageSearchOption>) {
    const input = useStatePair('')
    switch (props.optionKey) {
        case "idNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.idNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "idMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.idMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "idMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.idMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetCouponIdEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetCouponIdEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetCouponIdNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetCouponIdNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetCouponIdMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetCouponIdMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetCouponIdMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetCouponIdMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "userIdEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.userIdEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "userIdNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.userIdNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "userIdMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.userIdMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "userIdMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.userIdMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetSolarUsageIdEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetSolarUsageIdEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetSolarUsageIdNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetSolarUsageIdNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetSolarUsageIdMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetSolarUsageIdMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetSolarUsageIdMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetSolarUsageIdMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetSolarUsageIdIsNull":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetSolarUsageIdIsNull}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetLunarUsageIdEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetLunarUsageIdEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetLunarUsageIdNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetLunarUsageIdNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetLunarUsageIdMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetLunarUsageIdMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetLunarUsageIdMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetLunarUsageIdMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetLunarUsageIdIsNull":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetLunarUsageIdIsNull}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetStarUsageIdEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetStarUsageIdEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetStarUsageIdNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetStarUsageIdNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetStarUsageIdMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetStarUsageIdMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetStarUsageIdMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetStarUsageIdMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "assetStarUsageIdIsNull":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.assetStarUsageIdIsNull}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'number'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "createdAtEq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.createdAtEq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'text'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "createdAtNeq":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.createdAtNeq}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'text'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "createdAtMin":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.createdAtMin}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'text'} />
                    </Field>
                </ListOptionWrapper>
            </>
        case "createdAtMax":
            return <>
                <ListOptionWrapper
                    {...props}
                    title={AssetCouponUsageSearchOptionDescription.createdAtMax}
                    input={input}
                    onApplyClick={(key, value) => {
                        props.onApplyClick(key, value)
                        input.setter('')
                    }}>
                    <Field>
                        <Input
                            value={input.value}
                            onChange={(_, data) => input.setter(data.value)}
                            type={'text'} />
                    </Field>
                </ListOptionWrapper>
            </>
    }
}

export function applyAssetCouponUsageSearchOption(key: keyof AssetCouponUsageSearchOption, value: string, into: StatePair<AssetCouponUsageSearchOption>) {
    switch (key) {
        case "idNeq":
            into.setter({
                ...into.value,
                idNeq: BigInt(value)
            })
            break
        case "idMin":
            into.setter({
                ...into.value,
                idMin: BigInt(value)
            })
            break
        case "idMax":
            into.setter({
                ...into.value,
                idMax: BigInt(value)
            })
            break
        case "assetCouponIdEq":
            into.setter({
                ...into.value,
                assetCouponIdEq: BigInt(value)
            })
            break
        case "assetCouponIdNeq":
            into.setter({
                ...into.value,
                assetCouponIdNeq: BigInt(value)
            })
            break
        case "assetCouponIdMin":
            into.setter({
                ...into.value,
                assetCouponIdMin: BigInt(value)
            })
            break
        case "assetCouponIdMax":
            into.setter({
                ...into.value,
                assetCouponIdMax: BigInt(value)
            })
            break
        case "userIdEq":
            into.setter({
                ...into.value,
                userIdEq: BigInt(value)
            })
            break
        case "userIdNeq":
            into.setter({
                ...into.value,
                userIdNeq: BigInt(value)
            })
            break
        case "userIdMin":
            into.setter({
                ...into.value,
                userIdMin: BigInt(value)
            })
            break
        case "userIdMax":
            into.setter({
                ...into.value,
                userIdMax: BigInt(value)
            })
            break
        case "assetSolarUsageIdEq":
            into.setter({
                ...into.value,
                assetSolarUsageIdEq: BigInt(value)
            })
            break
        case "assetSolarUsageIdNeq":
            into.setter({
                ...into.value,
                assetSolarUsageIdNeq: BigInt(value)
            })
            break
        case "assetSolarUsageIdMin":
            into.setter({
                ...into.value,
                assetSolarUsageIdMin: BigInt(value)
            })
            break
        case "assetSolarUsageIdMax":
            into.setter({
                ...into.value,
                assetSolarUsageIdMax: BigInt(value)
            })
            break
        case "assetSolarUsageIdIsNull":
            into.setter({
                ...into.value,
                assetSolarUsageIdIsNull: Boolean(value)
            })
            break
        case "assetLunarUsageIdEq":
            into.setter({
                ...into.value,
                assetLunarUsageIdEq: BigInt(value)
            })
            break
        case "assetLunarUsageIdNeq":
            into.setter({
                ...into.value,
                assetLunarUsageIdNeq: BigInt(value)
            })
            break
        case "assetLunarUsageIdMin":
            into.setter({
                ...into.value,
                assetLunarUsageIdMin: BigInt(value)
            })
            break
        case "assetLunarUsageIdMax":
            into.setter({
                ...into.value,
                assetLunarUsageIdMax: BigInt(value)
            })
            break
        case "assetLunarUsageIdIsNull":
            into.setter({
                ...into.value,
                assetLunarUsageIdIsNull: Boolean(value)
            })
            break
        case "assetStarUsageIdEq":
            into.setter({
                ...into.value,
                assetStarUsageIdEq: BigInt(value)
            })
            break
        case "assetStarUsageIdNeq":
            into.setter({
                ...into.value,
                assetStarUsageIdNeq: BigInt(value)
            })
            break
        case "assetStarUsageIdMin":
            into.setter({
                ...into.value,
                assetStarUsageIdMin: BigInt(value)
            })
            break
        case "assetStarUsageIdMax":
            into.setter({
                ...into.value,
                assetStarUsageIdMax: BigInt(value)
            })
            break
        case "assetStarUsageIdIsNull":
            into.setter({
                ...into.value,
                assetStarUsageIdIsNull: Boolean(value)
            })
            break
        case "createdAtEq":
            into.setter({
                ...into.value,
                createdAtEq: new Date(value)
            })
            break
        case "createdAtNeq":
            into.setter({
                ...into.value,
                createdAtNeq: new Date(value)
            })
            break
        case "createdAtMin":
            into.setter({
                ...into.value,
                createdAtMin: new Date(value)
            })
            break
        case "createdAtMax":
            into.setter({
                ...into.value,
                createdAtMax: new Date(value)
            })
            break
    }
}
